import React from "react";
import { useNavigate } from "react-router-dom";

import FlowStickyHeader from "../../checkout/components/FlowStickyHeader";
import FlowPageHead from "../../checkout/components/FlowPageHead";

const FinanceShell = ({
  title,
  backTo,
  backLabel = "Back",
  showBack = true,
  actions,
  children,
}) => {
  const navigate = useNavigate();

  const goBack = () => {
    if (backTo) navigate(backTo);
    else navigate(-1);
  };

  return (
    <div className="sy-flow fin full-bleed">
      <div className="sy-flow-shell">
        <FlowStickyHeader>
          <FlowPageHead
            title={title}
            actions={actions}
            back={
              showBack && (
                <button type="button" className="sy-flow-back" onClick={goBack}>
                  <svg viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M10 3 5 8l5 5" />
                  </svg>
                  {backLabel}
                </button>
              )
            }
          />
        </FlowStickyHeader>

        {children}
      </div>
    </div>
  );
};

export default FinanceShell;
